/**
 * Chorus - Effet de chorus stéréo
 * Ajoute de la largeur et du mouvement au son
 */

import * as Tone from 'tone';

export class Chorus {
    constructor() {
        // Chorus avec paramètres par défaut
        this.chorus = new Tone.Chorus({
            frequency: 1.5,      // Vitesse de modulation (Hz)
            delayTime: 3.5,      // Temps de delay (ms)
            depth: 0.7,          // Profondeur de modulation
            wet: 1               // 100% wet pour bus send
        }).start();

        // Entrée/sortie
        this.input = this.chorus;
        this.output = this.chorus;

        // Valeurs par défaut
        this._frequency = 1.5;
        this._delayTime = 3.5;
        this._depth = 0.7;
        this._mix = 0.3;  // Mix global (géré par le gain de sortie)
        this._isActive = true;  // Track active state for CPU optimization

        // Gain de sortie pour le mix
        this._outputGain = new Tone.Gain(this._mix);
        this.chorus.connect(this._outputGain);
        this.output = this._outputGain;
    }

    // === Getters ===
    get frequency() { return this._frequency; }
    get delayTime() { return this._delayTime; }
    get depth() { return this._depth; }
    get mix() { return this._mix; }

    // === Setters ===
    setFrequency(hz) {
        this._frequency = hz;
        this.chorus.frequency.value = hz;
    }

    setDelayTime(ms) {
        this._delayTime = ms;
        this.chorus.delayTime = ms;
    }

    setDepth(depth) {
        this._depth = depth;
        this.chorus.depth = depth;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    /**
     * Connecte le chorus à une destination
     */
    connectTo(destination) {
        this.output.connect(destination);
    }

    /**
     * Déconnecte la sortie
     */
    disconnect() {
        this.output.disconnect();
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * Sets frequency to 0 when inactive to stop LFO modulation
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;

        if (active) {
            // Restore original frequency
            this.chorus.frequency.value = this._frequency;
        } else {
            // Set frequency to 0 to stop modulation (saves CPU)
            this.chorus.frequency.value = 0;
        }
    }

    /**
     * Obtient les paramètres actuels
     */
    getParams() {
        return {
            frequency: this._frequency,
            delayTime: this._delayTime,
            depth: this._depth,
            mix: this._mix
        };
    }

    /**
     * Applique des paramètres
     */
    setParams(params) {
        if (params.frequency !== undefined) this.setFrequency(params.frequency);
        if (params.delayTime !== undefined) this.setDelayTime(params.delayTime);
        if (params.depth !== undefined) this.setDepth(params.depth);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this.chorus.dispose();
        this._outputGain.dispose();
    }
}
